/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import styled from 'styled-components';
import {
  theme,
  Text,
  TableComponent,
  ButtonAnt,
} from '@pfmam/pfmam';
import { Link } from 'react-router-dom';
import { InfoCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Box, Container } from '../../../styles/globalStyle';
import NoDataFound from '../../../common/components/noDataFound';
import AccountActions from '../accountActions';
import { Tooltip } from 'antd';
import moment from 'moment';
const Wrapper = styled.div`
  padding-top: 40px;
`;

const AchAccountsContainer = ({
  achAccounts,
  handleAction,
  handleMenuClick,
  canEditWiresAccount = false,
  webuserAccessType,
  isGlobalSettingsPage,
}) => {
  const getColumns = () => {
    const permissionColumn = {
      title: 'Permissions',
      dataIndex: 'permissions',
      key: 'permissions',
      sorter: false,
      className: 'sort-space-none',
      width: 400,
      render: (text) => (
        <>
          {text && text.length > 0 ? (
            text.map((permission) => {
              return (
                <Text lineheight="20px" margin="0 0 4px 0" label={permission} />
              );
            })
          ) : (
            <Text
              fontSize={`${theme.font_size.size_xl}`}
              color={`${theme.colors.grey_tertiary}`}
              lineheight="20px"
              margin="4px 0 0"
              label={'- - - -'}
            />
          )}
        </>
      ),
    };
    const columns = [
      {
        title: 'Bank / Nickname',
        dataIndex: 'bankName',
        key: 'bankName',
        align: 'left',
        sorter: (a, b) => a.bankName.localeCompare(b.bankName),
        className: 'sort-space-none',
        width: 400,
        render: (text, record) => (
          <>
            {text}{' '}
            <Text
              fontSize={`${theme.font_size.size_xl}`}
              color={`${theme.colors.grey_tertiary}`}
              lineheight="20px"
              margin="4px 0 0"
              label={record.nickName ? record.nickName : '- - - -'}
            />
            {isGlobalSettingsPage && record.pending === 0 ? (
              <Box
                boxcolor="#F49B48"
                radius="2px"
                padding="2px 8px"
                textalign="center"
                margin="8px 0 0"
                display="inline-block"
              >
                <Text
                  label="Awaiting Admin Approval"
                  fontSize={`${theme.font_size.size_m}`}
                  color={`${theme.colors.black_secondary}`}
                  lineheight="16px"
                />
              </Box>
            ) : null}

          </>
        ),
      },
      {
          title: 'Last Modified (ET)',
          dataIndex: 'lastModifiedDate',
          key: 'lastModifiedDate',
          sorter: (a, b) =>{
            var aDate =a.lastModifiedDate;
            var bDate= b.lastModifiedDate;
            if(aDate===null)
            {
              aDate= moment("1900-01-01");
            }
            if(bDate===null)
            {
              bDate = moment("1900-01-01");
            }
            return moment(aDate).unix() - moment(bDate).unix();
            
          },
          className: 'sort-space-none',
          width: 300,
          render: (text) => (
            <Text
              label={
              // Avoiding using Moment library because it keeps screwing up the timezone. The CST to EST conversion is now made in the database
               text != null
                ? new Date(text).toLocaleString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                })
              : null
              }
            />
          ),
        },
      {
        title: 'Name on Account',
        dataIndex: 'nameOnAccount',
        key: 'nameOnAccount',
        sorter: (a, b) => a.nameOnAccount.localeCompare(b.nameOnAccount),
        className: 'sort-space-none',
        width: 320,
      },
      {
        title: '',
        dataIndex: 'righticon',
        key: 'righticon',
        align: 'right',
        className: 'action-cell',
        width: 80,
        render: (_, record) => (
          <AccountActions
            type="ACH"
            record={record}
            canEditWiresAccount={canEditWiresAccount}
            handleMenuClick={handleMenuClick}
            isGlobalSettingsPage={isGlobalSettingsPage}
          />
        ),
      },
    ];
    if (isGlobalSettingsPage) {
      columns.splice(2, 0, permissionColumn);
    }
    return columns;
  };

  return (
    <Container>
      <Wrapper>
        <TableComponent
          className="table-primary"
          title={
            <Box
              display="flex"
              justifycontent="space-between"
              alignitems="center"
              padding="24px 48px 24px 32px"
              border={`1px solid ${theme.colors.grey_fossil}`}
              borderwidth="0 0 1px 0"
            >

              <Box display="flex" justifycontent="space-between">
                <Text
                  label="Linked ACH Accounts"
                  fontSize={`${theme.font_size.size_3xl}`}
                  lineheight="32px"
                  color={`${theme.colors.black_tertiary}`}
                />
                {!isGlobalSettingsPage ? <Tooltip title="To view Pending ACH Instructions, visit the ACH Instructions page under Organizational Settings. Associated instructions will appear once out of Pending status."
                  overlayClassName="tooltip">
                  <InfoCircleOutlined
                    style={{ padding: '2px 2px 2px 2px', cursor: 'pointer' }}
                  />
                </Tooltip> : null}
              </Box>
              {webuserAccessType == 0 && canEditWiresAccount ? (
                <Link
                  to={{
                    pathname: '/aba-lookup/ach',
                  }}
                >
                  <ButtonAnt
                    type="link"
                    label="Link New ACH Account"
                    icon={<PlusCircleOutlined />}
                    onClick={(e) => {
                      handleMenuClick(e, null, 'ACH');
                    }}
                  />
                </Link>
              ) : null}



              {/* {isGlobalSettingsPage ? (
                <ButtonAnt
                  type="link"
                  label="Add ACH Accounts"
                  icon={<PlusCircleOutlined />}
                  onClick={(e) => {
                    handleMenuClick(e, null, 'ACH');
                  }}
                />
              ) : (
                <Link
                  to={{
                    pathname: '/settings',
                    accType: 'ACH',
                  }}
                >
                  <ButtonAnt type="link" label="Manage ACH Accounts" />
                </Link>
              )} */}
            </Box>
          }
          columns={getColumns()}
          dataSource={achAccounts}
          locale={{
            emptyText: <NoDataFound text="No ACH accounts" />,
          }}
          showSorterTooltip={false}
          pagination={
            achAccounts.length > 10
              ? {
                  position: ['bottomRight'],
                  showQuickJumper: true,
                  size: 'default',
                }
              : false
          }
          onRow={(record) => ({
            onClick: () => {
              handleAction('ACH', 'details', record);
            },
          })}
        />
      </Wrapper>
    </Container>
  );
};

export default AchAccountsContainer;
